// extracted by mini-css-extract-plugin
module.exports = {"footer":"home_footer__5Yx57","emptyCategory":"home_emptyCategory__Q0rek"};